import { useRoutes } from 'react-router-dom'

import {
  affiliatesRoutes,
  airdropRoutes,
  bannerRoutes,
  daoRoutes,
  faqRoutes,
  dashboardRoutes,
  marketplaceRoutes,
  p2pRoutes,
  promoCodeRoutes,
  propertyActivitiesRoutes,
  ptoRoutes,
  publicRoutes,
  settingRoutes,
  stakingRoutes,
  userRoutes,
  vestingRoutes,
  whatsNewRoutes,
} from './routes/modules'

const routes = [
  ...dashboardRoutes,
  ...stakingRoutes,
  ...p2pRoutes,
  ...ptoRoutes,
  ...promoCodeRoutes,
  ...propertyActivitiesRoutes,
  ...daoRoutes,
  ...userRoutes,
  ...affiliatesRoutes,
  ...vestingRoutes,
  ...airdropRoutes,
  ...marketplaceRoutes,
  ...settingRoutes,
  ...bannerRoutes,
  ...whatsNewRoutes,
  ...faqRoutes,
  ...publicRoutes,
]

const PageRoutes = () => {
  return useRoutes(routes)
}

export default PageRoutes
